'use strict'
module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/index.js
// module id = 884
// module chunks = 95715928098905 168707334958949